import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useNotify } from "hooks/notify";
import { EmissionAllocation, EmissionsAllocationDetails, EmissionsAllocationOverviewData, EmissionsAllocationOverviewRequestBody, getAllEmissionsAllocations, getEmissionAllocationById, getEmissionsAllocationOverview } from "api";

export const useEmissionsAllocation = () => {
    const notify = useNotify();

    return useQuery<EmissionAllocation[], AxiosError>({
        queryKey: ['emissionsAllocations'],
        queryFn: getAllEmissionsAllocations,
        onError: (err) => {
            notify.error(typeof err.response?.data === 'string' ? err.response?.data : 'Failed to load Emissions Allocation Setup Data.');
        },
    })
};

export const useEmissionAllocationById = (id: number) => {
    const notify = useNotify();

    return useQuery<EmissionsAllocationDetails, AxiosError>({
        queryKey: ['emissionsAllocationDetails', id],
        queryFn: () => getEmissionAllocationById(id),
        keepPreviousData: false,
        onError: (err) => {
            notify.error(typeof err.response?.data === 'string' ? err.response?.data : 'Failed to load Emissions Allocation Details.');
        },
    })
};

export const useEmissionAllocationOverviewById = (body: EmissionsAllocationOverviewRequestBody) => {
    const notify = useNotify();

    return useQuery<EmissionsAllocationOverviewData[], AxiosError>({
        queryKey: ['emissionsAllocationOverview', body],
        queryFn: () => getEmissionsAllocationOverview(body),
        keepPreviousData: false,
        onError: (err) => {
            notify.error(typeof err.response?.data === 'string' ? err.response?.data : 'Failed to load Emissions Allocation data.');
        },
    })
};